import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { LoggingService } from '../../service/logging-service/logging.service';

export interface Data {
  event: EventSession;
  result: EventResult;
  redirectLink?: string;
  deeplink?: string;
  sessionId: string;
  authorizationId: string;
  paymentId?: string;
  signingBasketId?: string;
  verifiedAccountId?: string;
  activity?: string;
  redirectUri: string;
}

enum EventSession {
  REDIRECT = 'redirect',
  DEEPLINK = 'deeplink',
  COMPLETE = 'session-complete',
  ACTIVITY = 'session-activity',
}

export enum EventResult {
  SUCCESS = 'Success',
  ERROR = 'Error',
  CANCELED = 'Canceled',
}

@Component({
  selector: 'app-finshark-iframe',
  templateUrl: './finshark-iframe.component.html',
  styleUrls: ['./finshark-iframe.component.css'],
})
export class FinsharkIframeComponent {
  constructor(private loggingService: LoggingService) {}
  @Input() iframeUrl: SafeResourceUrl;
  @Output() onEventData: EventEmitter<Data> = new EventEmitter();

  frameEventListener: EventListenerOrEventListenerObject =
    this.handleFrameMessage.bind(this);

  ngOnDestroy(): void {
    window.removeEventListener('message', this.frameEventListener, false);
  }

  ngAfterViewInit(): void {
    window.addEventListener('message', this.frameEventListener, false);
  }

  handleFrameMessage(finsharkMessageData: MessageEvent): void {
    if (finsharkMessageData.origin !== 'https://flows.finshark.io') {
      return; //Ignore message if not sent by finshark...
    }

    if (finsharkMessageData && finsharkMessageData.data) {
      const data: Data = finsharkMessageData.data;

      this.loggingService.warn(
        'Finshark responded with data: ' + JSON.stringify(data)
      );

      if (data.event === EventSession.REDIRECT && data.redirectLink) {
        window.open(data.redirectLink, '_blank'); //Open bank site link in new tab --> Closes on complete.
      }

      if (data.event === EventSession.DEEPLINK && data.deeplink) {
        window.location.assign(data.deeplink); //Deeplinks to the authentication app i.e BankId.
      }

      if (data.event === EventSession.COMPLETE) {
        this.onEventData.emit(data);
      }
    }
  }
}
